/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2017 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/

import { Component, OnInit } from "@angular/core";
import { LayoutService } from "../../services/layoutservice.service";
import { Subscription } from "rxjs";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  isOpened = false;
  subscription: Subscription;
  notificationsList;
  notificationstatus: string;
  notifyCount: any;
  maintenance: any;
  constructor(private _layoutService: LayoutService, private router: Router) {
    _layoutService.user$.subscribe((userName) => {
      this.username = userName;
    });
    _layoutService.notificationstatus$.subscribe((notificationstatus) => {
      this.notificationstatus = notificationstatus;
    });
    _layoutService.notifyCount$.subscribe((notifyCount) => {
      this.notifyCount = notifyCount;
    });
    _layoutService.maintain$.subscribe((maintain) => {
      this.maintenance = maintain;
    });

    this.notificationstatus = localStorage.getItem("notification");
    this.username = localStorage.getItem("username");
    this.notificationsList = localStorage.getItem("notificationsData");
    this.notifyCount = localStorage.getItem("notifyCount");
    if (JSON.parse(sessionStorage.getItem("maintenance"))) {
      this.maintenance = JSON.parse(sessionStorage.getItem("maintenance"));
    } else {
      this.maintenance = "";
    }
  }
  username: string;

  notificationCount() {
    this.notificationsList = JSON.parse(
      localStorage.getItem("notificationsData")
    );
    this.isOpened = true;
    //     localStorage.setItem("notification", "false");
    //     this.notificationstatus = localStorage.getItem("notification");
    // this._layoutService.getNotificationData().subscribe(
    //   (res) => {
    //     this.notificationsList = res;
    //     this.isOpened = true;
    //     //this.notifyCount=res.length;
    //     localStorage.setItem("notification", "false");
    //     this.notificationstatus = localStorage.getItem("notification");
    //   },
    //   (error) => {
    //     this.router.navigate(["./error"]);
    //   }
    // );
  }

  closeIconClick() {
    this.isOpened = false;
  }

  logout() {
    this.isOpened = false;
    this._layoutService.logout();
    //this.router.navigate(['landing']);
    //this.router.navigate(["login"]);
  }

  ngOnInit() {
    this.subscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => window.scrollTo(0, 0));
    //this.username = localStorage.getItem("username");
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  navigateToHome() {
    let userId = localStorage.getItem("username");
    if (userId) {
      this.router.navigate(["./home"]);
    } else {
      return false;
    }
  }
}
